import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ActionListOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/ActionListOperandExpressionNodeConverter";
import { AbstractStandardOperandMultiplexExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/multiplex/AbstractStandardOperandMultiplexExpressionNodeConverter";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
import { Assert } from "abweb/utils/Assert";
// import AbstractOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue;

export class AbstractOperandMultiplexExpressionNodeConverter {
  constructor(specification) {
    _defineProperty(this, "_specification", void 0);
    this._specification = specification;
  }
  get specification() {
    return this._specification;
  }
  convert(expExpressionNode) {
    switch (expExpressionNode.nodeType) {
      case ExpExpressionNodeNodeTypeEnum.ACTION_LIST:
        return new ActionListOperandExpressionNodeConverter(this.specification).convert(expExpressionNode);
      case ExpExpressionNodeNodeTypeEnum.LITERAL:
      case ExpExpressionNodeNodeTypeEnum.REFERENCE:
      case ExpExpressionNodeNodeTypeEnum.OPERATOR:
        return new AbstractStandardOperandMultiplexExpressionNodeConverter(this.specification).convert(expExpressionNode);
      default:
        this.reportUnexpectedNodeType(expExpressionNode);
    }
  }
  reportUnexpectedNodeType(expExpressionNode) {
    Assert.unexpected(`Unexpected expression node type: ${expExpressionNode.nodeType}`);
  }
}
//# sourceMappingURL=AbstractOperandMultiplexExpressionNodeConverter.js.map
